const host = window.location.hostname;
const protocol = window.location.protocol || 'http:';
const origin = window.location.origin;
const isLocalEnv =
  host === 'localhost' ||
  host === '127.0.0.1' ||
  host.startsWith('192.168.') ||
  host.startsWith('10.') ||
  host.startsWith('172.');

export const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL || (isLocalEnv ? `${protocol}//${host}:5000` : '/api');

export const authBaseUrl =
  process.env.REACT_APP_AUTH_URL || (isLocalEnv ? `${protocol}//${host}:5001` : '/auth');

export const socketBaseUrl =
  process.env.REACT_APP_SOCKET_URL || (isLocalEnv ? `${protocol}//${host}:5000` : origin);

export const wppBaseUrl =
  process.env.REACT_APP_WPP_BASE_URL || (isLocalEnv ? `${protocol}//${host}:3001` : '/wpp');

export const metricsBaseUrl =
  process.env.REACT_APP_METRICS_URL || `${apiBaseUrl}/atendimento_metrics`;

export const projectMetricsBaseUrl =
  process.env.REACT_APP_PROJECT_METRICS_URL || `${apiBaseUrl}/projects/metrics`;
